import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = useCallback(
    key => {
      return searchParams.get(key);
    },
    [searchParams]
  );

  const getAllParams = useCallback(() => {
    const obj = {};
    searchParams.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }, [searchParams]);

  const setParam = useCallback(
    (key, value) => {
      const params = new URLSearchParams(searchParams);
      const options = { replace: true };

      // One-argument delete on purpose: delete(key, value) only drops pairs whose
      // value equals String(value), so null/'' would leave the key in place.
      if (value === null || value === '' || value === undefined) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
      setSearchParams(params, options);
    },
    [searchParams, setSearchParams]
  );

  const setParams = useCallback(
    (newParams = {}) => {
      const params = new URLSearchParams(searchParams);
      const options = { replace: true };

      Object.entries(newParams).forEach(([key, value]) => {
        if (value === null || value === '' || value === undefined) {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });

      setSearchParams(params, options);
    },
    [searchParams, setSearchParams]
  );

  const removeParam = useCallback(
    key => {
      const params = new URLSearchParams(searchParams);
      const options = { replace: true };
      params.delete(key);

      setSearchParams(params, options);
    },
    [searchParams, setSearchParams]
  );

  return {
    getParam,
    getAllParams,
    setParam,
    setParams,
    removeParam,
    searchParams,
  };
};
export default useQueryParams;
